var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RewardCardList",
      "extra-items": _vm.isReadOnly ? [{
        text: _vm.rewardCard.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, {
        text: '集點任務',
        to: 'RewardMissionList',
        params: _vm.$route.params.reward_card_id
      }, {
        text: _vm.form.title
      }] : _vm.isEditing ? [{
        text: _vm.rewardCard.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, {
        text: '集點任務',
        to: 'RewardMissionList',
        params: _vm.$route.params.reward_card_id
      }, {
        text: _vm.form.title
      }, '編輯集點任務'] : [{
        text: _vm.rewardCard.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, {
        text: '集點任務',
        to: 'RewardMissionList',
        params: _vm.$route.params.reward_card_id
      }, '新增集點任務']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _c('div', {
    staticClass: "mb-2"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "任務名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.title.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "by_card"
    },
    model: {
      value: _vm.form.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "period_type", $$v);
      },
      expression: "form.period_type"
    }
  }, [_vm._v(" 與集點卡相同 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "custom"
    },
    model: {
      value: _vm.form.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "period_type", $$v);
      },
      expression: "form.period_type"
    }
  }, [_vm._v(" 自訂期限 ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly || _vm.form.period_type !== 'custom',
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.start_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_at", $$v);
      },
      expression: "form.start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly || _vm.form.period_type !== 'custom',
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.end_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_at", $$v);
      },
      expression: "form.end_at"
    }
  })], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.start_at.beforeEndAt.$invalid')
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "可累點數"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.earn_point.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.earn_point,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "earn_point", $$v);
      },
      expression: "form.earn_point"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.earn_point.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "取得點數限制"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "id": "limit1"
    },
    model: {
      value: _vm.form.config.enable_total_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "enable_total_limit", $$v);
      },
      expression: "form.config.enable_total_limit"
    }
  }), _c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "limit1"
    }
  }, [_vm._v(" 每人上限 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "readonly": _vm.isReadOnly || _vm.form.config.enable_total_limit !== true,
      "type": 'number'
    },
    model: {
      value: _vm.form.config.total_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "total_limit", $$v);
      },
      expression: "form.config.total_limit"
    }
  }), _vm._v(" 次 ")], 1)], 1), _c('b-form-invalid-feedback', {
    staticClass: "mb-2",
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.total_limit.$error')
    }
  }, [_vm._v(" 此欄位為必填且必須為數字 ")]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "id": "limit2"
    },
    model: {
      value: _vm.form.config.enable_multi_period_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "enable_multi_period_limit", $$v);
      },
      expression: "form.config.enable_multi_period_limit"
    }
  }), _c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "limit2"
    }
  }, [_vm._v(" 每 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "readonly": _vm.isReadOnly || _vm.form.config.enable_multi_period_limit !== true,
      "type": 'number',
      "min": "1"
    },
    model: {
      value: _vm.form.config.multi_period_limit.period_value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.multi_period_limit, "period_value", $$v);
      },
      expression: "form.config.multi_period_limit.period_value"
    }
  }), _c('b-form-select', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "disabled": _vm.isReadOnly || _vm.form.config.enable_multi_period_limit !== true,
      "options": _vm.periodUnitOptions
    },
    model: {
      value: _vm.form.config.multi_period_limit.period_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.multi_period_limit, "period_unit", $$v);
      },
      expression: "form.config.multi_period_limit.period_unit"
    }
  }), _vm._v(" 每人上限 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "readonly": _vm.isReadOnly || _vm.form.config.enable_multi_period_limit !== true,
      "type": 'number',
      "min": "1"
    },
    model: {
      value: _vm.form.config.daily_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "daily_limit", $$v);
      },
      expression: "form.config.daily_limit"
    }
  }), _vm._v(" 次 ")], 1)], 1), _c('b-form-invalid-feedback', {
    staticClass: "mb-2",
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.multi_period_limit.period_value.$error')
    }
  }, [_vm._v(" 期間值為必填且必須為數字 ")]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "id": "limit3"
    },
    model: {
      value: _vm.form.config.enable_period_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "enable_period_limit", $$v);
      },
      expression: "form.config.enable_period_limit"
    }
  }), _c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "limit3"
    }
  }, [_vm._v(" 於 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "readonly": _vm.isReadOnly || _vm.form.config.enable_period_limit !== true,
      "type": 'number'
    },
    model: {
      value: _vm.form.config.period_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "period_limit", $$v);
      },
      expression: "form.config.period_limit"
    }
  }), _vm._v(" 小時內不得重複 ")], 1)], 1), _c('b-form-invalid-feedback', {
    staticClass: "mb-2",
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.period_limit.$error')
    }
  }, [_vm._v(" 此欄位為必填且必須為數字 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "入點檢核方式"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "none"
    },
    model: {
      value: _vm.form.config.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "confirm_type", $$v);
      },
      expression: "form.config.confirm_type"
    }
  }, [_vm._v(" 無須檢核 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "input"
    },
    model: {
      value: _vm.form.config.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "confirm_type", $$v);
      },
      expression: "form.config.confirm_type"
    }
  }, [_vm._v(" 輸入店號檢核 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "select"
    },
    model: {
      value: _vm.form.config.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "confirm_type", $$v);
      },
      expression: "form.config.confirm_type"
    }
  }, [_vm._v(" 選擇店號檢核 ")]), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "20rem"
    },
    attrs: {
      "readonly": _vm.isReadOnly,
      "placeholder": "分店下拉選單來源"
    },
    model: {
      value: _vm.form.config.branch_provider,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "branch_provider", $$v);
      },
      expression: "form.config.branch_provider"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "dynamic_verification"
    },
    model: {
      value: _vm.form.config.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "confirm_type", $$v);
      },
      expression: "form.config.confirm_type"
    }
  }, [_vm._v(" 動態店號核銷 ")])], 1)])], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), false == _vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }